import { render } from "./PasswordReset.vue?vue&type=template&id=b642c8e4"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
script.render = render

export default script